import portrait from '../dp.jpeg';
import PageHeader from '../Components/PageHeader';
import ContactBand from '../Components/ContactBand';

const facts = [
  { label: 'Education', value: 'Bachelor of Technology, Electronics and Communications' },
  { label: 'Previous experience', value: 'Network Consultant at Huawei Telecommunications and Cisco Networks Inc.' },
  { label: 'Years in industry', value: 'Seven years with major MNCs, 2009–2016' },
];

const About = () => (
  <>
    <PageHeader eyebrow="Leadership" title="Meet our founder" />

    <section className="section">
      <div className="container profile">
        <img className="profile__image" src={portrait} alt="Prafful Singh, Proprietor of Sneh Communications" />
        <div>
          <p className="eyebrow">Proprietor</p>
          <h2>Prafful Singh</h2>
          <p className="lead">
            After completing a Bachelor of Technology in Electronics and Communications, Prafful Singh
            worked in major MNCs including Huawei Telecommunications and Cisco Networks Inc. as a
            Network Consultant for seven years (2009–2016), before starting his own venture catering
            to the needs of hospitals and diagnostic centres and bridging the gap between
            manufacturers and centres.
          </p>
          <p className="lead">
            Sneh Communications has grown from the ground up to an average turnover of $3.2 million
            USD in the last six years.
          </p>
          <dl className="fact-list">
            {facts.map((fact) => (
              <div key={fact.label}>
                <dt>{fact.label}</dt>
                <dd>{fact.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>

    <ContactBand />
  </>
);

export default About;
